import { PageMessage } from "@/common/StyledComponents"

export default function _404() {
    return (
        <PageMessage>Page not found.</PageMessage>
    )
}
